import $ from 'jquery';

const checklistIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M10 0C4.49 0 0 4.49 0 10C0 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 0 10 0ZM14.78 7.7L9.11 13.37C8.97 13.51 8.78 13.59 8.58 13.59C8.38 13.59 8.19 13.51 8.05 13.37L5.22 10.54C4.93 10.25 4.93 9.77 5.22 9.48C5.51 9.19 5.99 9.19 6.28 9.48L8.58 11.78L13.72 6.64C14.01 6.35 14.49 6.35 14.78 6.64C15.07 6.93 15.07 7.4 14.78 7.7Z" fill="#12B76A"/>
</svg>`;

const closeIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M7.99967 1.33333C4.32634 1.33333 1.33301 4.32666 1.33301 8C1.33301 11.6733 4.32634 14.6667 7.99967 14.6667C11.673 14.6667 14.6663 11.6733 14.6663 8C14.6663 4.32666 11.673 1.33333 7.99967 1.33333ZM10.2397 9.53333C10.433 9.72666 10.433 10.0467 10.2397 10.24C10.1397 10.34 10.013 10.3867 9.88634 10.3867C9.75968 10.3867 9.63301 10.34 9.53301 10.24L7.99967 8.70666L6.46634 10.24C6.36634 10.34 6.23967 10.3867 6.11301 10.3867C5.98634 10.3867 5.85967 10.34 5.75968 10.24C5.56634 10.0467 5.56634 9.72666 5.75968 9.53333L7.29301 8L5.75968 6.46666C5.56634 6.27333 5.56634 5.95333 5.75968 5.76C5.95301 5.56666 6.27301 5.56666 6.46634 5.76L7.99967 7.29333L9.53301 5.76C9.72634 5.56666 10.0463 5.56666 10.2397 5.76C10.433 5.95333 10.433 6.27333 10.2397 6.46666L8.70634 8L10.2397 9.53333Z" fill="#667085"/>
</svg>`;


const formToast = (title, message) => {
    // Inject styles if not already present

    // Create container if not already present
    if (!$('#toast-container').length) {
        $('<div id="toast-container">').appendTo('body');
    }

    const $toast = $(`
    <div class="toast" role="alert" aria-live="assertive">
      <div class="toast-icon">${checklistIcon}</div>
      <div class="toast-body">
        <p class="toast-title">${title}</p>
        <p class="toast-message">${message}</p>
      </div>
      <button class="toast-close" aria-label="Close">${closeIcon}</button>
    </div>
  `);

    $('#toast-container').append($toast);

    // Trigger show animation
    requestAnimationFrame(() => {
        $toast.addClass('toast-show');
    });

    // Helper to clean up URL parameters
    const cleanUrl = () => {
        const url = new URL(window.location.href);
        if (url.searchParams.has('success')) {
            url.searchParams.delete('success');
            window.history.replaceState({}, document.title, url.toString());
        }
    };

    // Close button handler
    $toast.find('.toast-close').on('click', () => {
        $toast.removeClass('toast-show').addClass('toast-hide');
        setTimeout(() => {
            $toast.remove();
            cleanUrl();
        }, 300);
    });

    // Auto-dismiss after 5 seconds
    setTimeout(() => {
        if ($toast.length && $.contains(document, $toast[0])) {
            $toast.removeClass('toast-show').addClass('toast-hide');
            setTimeout(() => {
                $toast.remove();
                cleanUrl();
            }, 300);
        }
    }, 5000);
};

try {
    $(document).ready(() => {
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has('success')) {
            const successType = urlParams.get('success');
            let title = '';
            let message = '';

            if (successType === 'ebook') {
                title = 'E-book Request Successful!';
                message = 'Your e-book request was successful. Please check your email for the download link.';
                formToast(title, message);
            } else if (successType === 'webinar') {
                title = 'Webinar Registration Successful!';
                message = 'You have successfully signed up for the webinar. The link has been sent to your email.';
                formToast(title, message);
            } else if (successType === 'true') {
                // Default fallback
                title = 'Your knowledge has been posted!';
                message = 'Your submission will be reviewed before being published in Free E-books.';
                formToast(title, message);
            }
        }
    });
} catch (err) {
    console.log(err);
}